import React from "react";

import iconList from "./icons";

import { camelCase } from "lodash";
export default class Icon extends React.Component {
  constructor(props) {
    super(props);

    /**
     * @type {{
     *  type: 'calendar'|'clock'|'minus'|'trophy'|'wallet'|'arrow-left'|'chevron-down'|'chevron-up'|'chevron-right'|'undone-circle'|'done-circle',
     *  color: 'main'|'white'|'danger'
     * }}
     */
    this.props;

    /**
     * @type {{
     *  iconId: string,
     *  component: React.Component|React.FC
     * }}
     */
    this.state = {
      iconId: `icon-${Math.random().toString().substring(2)}`,
      component: iconList[camelCase(props.type)] || null,
      template: window["colorTemplate"],
    };
  }

  render() {
    const { type, color, width, height, style } = this.props;
    const { iconId, component: IconSVG } = this.state;

    return (
      <React.Fragment>
        {IconSVG ? (
          <IconSVG id={iconId} width={width} height={height} style={style} />
        ) : (
          <img src={`/assets/icons/${type}--${color}.svg`} />
        )}
      </React.Fragment>
    );
  }

  componentDidMount() {
    this.updateColors();
  }

  componentDidUpdate() {
    this.updateColors();
  }

  updateColors() {
    const { iconId, template } = this.state;
    const svgPaths = document.querySelectorAll(`#${iconId} > *`);

    if (svgPaths && template) {
      const colorHex = template[this.props.color];
      svgPaths.forEach((path) => {
        if (path.getAttribute("stroke")) path.setAttribute("stroke", colorHex);
        if (path.getAttribute("fill")) path.setAttribute("fill", colorHex);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/rifa/components/layout/icon.jsx